const Label = (props) => {
  return <label {...props}></label>;
};

export default Label;
